import { m } from "../paraglide/messages";

export const SELECT_SEARCH_THRESHOLD = 10;

export type LabelFormatterFn = (item: string) => string;

export type SummaryFormatterFn = (count: number) => string;

export const defaultSummaryFormatter: SummaryFormatterFn = (count) =>
  count === 1 ? m.one_item_selected() : m.n_items_selected({ count });
